module.exports = __webpack_public_path__ + "img/seo_gfish_item01.b752561.webp";